export default function (scrTop = 0) {
  return {
    data() {
      return {
        srcoll_flag_state: false,
      }
    },
    mounted() {
      window.addEventListener('scroll', this.__scrollToTop__)
    },
    destroyed() {
      window.removeEventListener('scroll', this.__scrollToTop__)
    },
    methods: {
      __scrollToTop__() {
        const scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop

        this.srcoll_flag_state = scrollTop > scrTop
      },
    },
  }
}
